import { referenceSegment } from '../lib/scope-groups.ts'

// the first underscore separates org from content repo: 01-edu_module -> 01-edu/module
export const ReferenceBadge = ({ referencePath }: { referencePath?: string }) =>
  referencePath
    ? (
      <span class='font-mono text-xs text-primary' title={referencePath}>
        {referenceSegment(referencePath)?.replace('_', '/')}
      </span>
    )
    : null
